
export const BACKEND_URL = "https://blogapp-yakt.onrender.com" || "http://localhost:8000";
// "" ; 